/* 42KM customer accounts: sign-in / forgot-password views, password helpers, submit states,
   address book. Everything degrades gracefully: without JavaScript the forms still post. */
(function () {
  // ---------- Sign in <-> Forgot password ----------
  var auth = document.querySelector('[data-acct-auth]');
  if (auth) {
    var views = auth.querySelectorAll('[data-acct-view]');

    var show = function (name, focus) {
      auth.classList.toggle('is-recover', name === 'recover');
      views.forEach(function (v) {
        v.hidden = v.getAttribute('data-acct-view') !== name;
      });
      var target = auth.querySelector('[data-acct-view="' + name + '"]');
      if (focus && target) {
        var field = target.querySelector('input[type="email"]');
        if (field) {
          // Carry the email over between the two forms so nobody types it twice
          var other = auth.querySelector('[data-acct-view]:not([data-acct-view="' + name + '"]) input[type="email"]');
          if (other && other.value && !field.value) field.value = other.value;
          field.focus({ preventScroll: true });
        }
        // Bring the form back into view; the page header stays visible when the form starts near the top
        var top = auth.getBoundingClientRect().top + window.scrollY;
        var dest = top < 600 ? 0 : top - 20;
        if (window.scrollY > dest) window.scrollTo({ top: dest, behavior: 'smooth' });
      }
    };

    // Server already decided (e.g. after a failed reset request) via .is-recover; else follow the hash
    var initial = auth.classList.contains('is-recover') || location.hash === '#recover' ? 'recover' : 'login';
    show(initial, false);
    if (location.hash === '#recover') {
      history.replaceState(null, '', location.pathname + location.search + '#recover');
    }

    auth.addEventListener('click', function (e) {
      var link = e.target.closest('[data-acct-show]');
      if (!link) return;
      e.preventDefault();
      var name = link.getAttribute('data-acct-show');
      show(name, true);
      history.replaceState(null, '', location.pathname + location.search + (name === 'recover' ? '#recover' : ''));
    });

    window.addEventListener('hashchange', function () {
      show(location.hash === '#recover' ? 'recover' : 'login', true);
    });
  }

  // ---------- Focus the first message after a submit (screen readers + scroll) ----------
  var msg = document.querySelector('[data-acct-focus]');
  if (msg && msg.offsetParent !== null) {
    msg.focus({ preventScroll: true });
    var r = msg.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight) {
      window.scrollTo({ top: r.top + window.scrollY - 120, behavior: 'smooth' });
    }
  }

  // ---------- Show / hide password ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-acct-pw]');
    if (!btn) return;
    var input = document.getElementById(btn.getAttribute('aria-controls'));
    if (!input) return;
    var showing = input.type === 'text';
    input.type = showing ? 'password' : 'text';
    btn.textContent = showing ? 'Show' : 'Hide';
    btn.setAttribute('aria-pressed', String(!showing));
    btn.setAttribute('aria-label', showing ? 'Show password' : 'Hide password');
    input.focus();
  });

  // ---------- Caps Lock warning ----------
  document.querySelectorAll('[data-acct-caps]').forEach(function (input) {
    var note = input.closest('.acct-field') && input.closest('.acct-field').querySelector('.acct-caps');
    if (!note) return;
    var check = function (e) {
      if (e.getModifierState) note.classList.toggle('is-on', e.getModifierState('CapsLock'));
    };
    input.addEventListener('keydown', check);
    input.addEventListener('keyup', check);
    input.addEventListener('blur', function () {
      note.classList.remove('is-on');
    });
  });

  // ---------- New password: confirm must match ----------
  var pwNew = document.querySelector('[data-acct-pw-new]');
  var pwConfirm = document.querySelector('[data-acct-pw-confirm]');
  var mismatch = document.querySelector('[data-acct-mismatch]');
  if (pwNew && pwConfirm) {
    var compare = function () {
      var bad = pwConfirm.value.length > 0 && pwConfirm.value !== pwNew.value;
      pwConfirm.setCustomValidity(bad ? "The passwords don't match" : '');
      pwConfirm.setAttribute('aria-invalid', String(bad));
      if (mismatch) mismatch.hidden = !bad;
    };
    pwNew.addEventListener('input', compare);
    pwConfirm.addEventListener('input', compare);
  }

  // ---------- Submit: validate, then show progress and block double submits ----------
  document.querySelectorAll('form[data-acct-submit]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      var declining = submitter && submitter.name === 'decline';
      if (!declining) {
        // These forms use novalidate (so Shopify's own messages show), so check required fields here
        var invalid = Array.prototype.find.call(form.querySelectorAll('input[required], select[required]'), function (el) {
          return !el.checkValidity() || (el.type === 'email' && el.value.trim() !== '' && el.value.indexOf('@') < 1);
        });
        if (invalid) {
          e.preventDefault();
          invalid.setAttribute('aria-invalid', 'true');
          invalid.focus();
          if (invalid.reportValidity) invalid.reportValidity();
          return;
        }
      }
      if (form.dataset.sending === 'true') {
        e.preventDefault();
        return;
      }
      form.dataset.sending = 'true';
      var btn = submitter || form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      // If the browser comes back via back/forward cache, let the form be used again
      window.addEventListener('pageshow', function () {
        form.dataset.sending = 'false';
        if (btn) btn.removeAttribute('aria-busy');
      });
    });
    form.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true' && input.checkValidity()) input.removeAttribute('aria-invalid');
      });
    });
  });

  // ---------- Address book ----------
  var book = document.querySelector('[data-acct-addresses]');
  if (book) {
    var setupCountries = function () {
      if (!window.Shopify || !Shopify.CountryProvinceSelector) return false;
      book.querySelectorAll('[data-acct-country]').forEach(function (select) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(select.id, select.dataset.province, {
          hideElement: select.dataset.provinceWrap,
        });
      });
      return true;
    };
    if (!setupCountries()) window.addEventListener('load', setupCountries);

    var openers = book.querySelectorAll('[data-acct-open]');
    var closeAll = function () {
      book.querySelectorAll('[data-acct-panel]').forEach(function (p) {
        p.hidden = true;
      });
      openers.forEach(function (o) {
        o.setAttribute('aria-expanded', 'false');
      });
    };

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('data-acct-open'));
        if (!panel) return;
        var wasOpen = !panel.hidden;
        closeAll();
        if (wasOpen) return;
        panel.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var first = panel.querySelector('input:not([type="hidden"]):not([type="checkbox"])');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
      });
    });

    book.addEventListener('click', function (e) {
      var close = e.target.closest('[data-acct-close]');
      if (close) {
        var panel = close.closest('[data-acct-panel]');
        var opener = panel && book.querySelector('[data-acct-open="' + panel.id + '"]');
        closeAll();
        if (opener) {
          opener.focus({ preventScroll: true });
          opener.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      var del = e.target.closest('[data-acct-delete]');
      if (del) {
        if (!window.confirm(del.getAttribute('data-confirm'))) return;
        if (window.Shopify && Shopify.postLink) {
          Shopify.postLink(del.getAttribute('data-acct-delete'), { parameters: { _method: 'delete' } });
        } else {
          // Fallback: same request Shopify.postLink makes
          var f = document.createElement('form');
          f.method = 'post';
          f.action = del.getAttribute('data-acct-delete');
          f.innerHTML = '<input type="hidden" name="_method" value="delete">';
          document.body.appendChild(f);
          f.submit();
        }
      }
    });
  }
})();
